import React from 'react'
import theme from './AuthenticationFailed.scss'
import errorImg from './warning.png';
import {BaseDialog} from "dialogs/BaseDialog";

/**
 * It's not possible to use Message Bundle here, because user may not see the message in case of the first login.
 */
export default class AuthenticationFailed extends BaseDialog {

    constructor(props) {
        super(props);

        this.state = {
            initialized: true
        };
    }

    getDialog() {
        return (
            <div className={theme.mainBox}>
                <div className={theme.errorDiv}>
                    <img src={errorImg} className={theme.imageClass} role="presentation"/>
                    <p>Sie sind nicht berechtigt, auf die Anwendung Reklamation Handel zuzugreifen. Bitte kontaktieren Sie den T-VPP Portal Support.</p>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/dialogs/AuthenticationFailed/index.js